// extracted by mini-css-extract-plugin
export default {"svg":"yWgAgeZI"};